import { FC } from 'react'
import { SvgProps } from '@/components/atoms/svg/svgProps'
const Belts: FC<SvgProps> = ({ width, height, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 154 76.22"
      width={width || 18}
      height={height || 18}
    >
      <use href="#belts-icon-definition" stroke={color || '#000'} />
    </svg>
  )
}
export default Belts
